<div *ngIf="data$ | async" class="w-full h-full flex flex-col justify-start items-stretch" fusePerfectScrollbar>
  <div id="materials-wrapper" class="p-4">
    <div class="flex flex-row flex-wrap justify-start items-center gap-6">
      <mat-form-field appearance="outline" class="basis-180 dense-input no-subscript">
        <mat-label i18n>Материал ({{ materials.length }} шт)</mat-label>
        <mat-select
          i18n-placeholder
          #selectMaterial
          [(value)]="selectedMaterial"
          (selectionChange)="selectedMaterial = $event.value"
          [disabled]="!validPanels || selectionMode"
          (click)="materials.length === 0 && editableOrder ? openMaterialBaseDialog() : null">
          <mat-option *ngFor="let item of materials" [value]="item">
            <span *ngIf="item">{{ getMaterialName(item) }}</span>
            <span *ngIf="!item">{{ item.name }}</span>
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div class="flex flex-row justify-start items-center gap-1">
        <button
          i18n-matTooltip
          mat-icon-button
          (click)="openMaterialBaseDialog()"
          matTooltip="Добавить материал"
          *ngIf="editableOrder"
          [disabled]="!validPanels || selectionMode">
          <mat-icon class="mat-24" aria-label="">add_circle_outline</mat-icon>
        </button>

        <button
          i18n-matTooltip
          mat-icon-button
          matTooltip="Удалить материал"
          (click)="deleteSelectedMaterial()"
          *ngIf="editableOrder"
          [disabled]="!validPanels || !selectedMaterial || selectionMode">
          <mat-icon class="mat-24" aria-label="">remove_circle_outline</mat-icon>
        </button>

        <button
          i18n-matTooltip
          mat-icon-button
          (click)="openMaterialBaseDialogForSwap()"
          matTooltip="Заменить материал"
          *ngIf="editableOrder"
          [disabled]="!validPanels || !selectedMaterial || selectionMode">
          <mat-icon class="mat-24" aria-label="">swap_horizontal_circle</mat-icon>
        </button>

        <button
          i18n-matTooltip
          mat-icon-button
          (click)="swapButts()"
          matTooltip="Заменить облицовку"
          *ngIf="editableOrder"
          [disabled]="!validPanels || !selectedMaterial || selectionMode">
          <mat-icon svgIcon="edge_swap"></mat-icon>
        </button>
      </div>

      <p i18n *ngIf="selectedMaterial" class="mat-body-2 sm:m-0"
        >Размер плиты: {{ selectedMaterial.height }} &times; {{ selectedMaterial.width }}</p
      >
    </div>
  </div>

  <csl-panel-list-v2
    #panelList
    [cuttingSettings]="cuttingSettings"
    [orderId]="orderId"
    fusePerfectScrollbar
    *ngIf="selectedMaterial !== undefined"
    [editableOrder]="editableOrder"
    (setPosInOrder)="setPanelsPosInOrder()"
    (setMissingPositions)="setMissingPanelPositions($event)"
    (valid)="validPanels = $event; valid.emit($event)"
    [inMatBaseIdMaterial]="selectedMaterial.inMaterialBaseId"
    [(panelList)]="selectedMaterial.panels"
    [mainMaterial]="selectedMaterial"
    [materialWidth]="selectedMaterial.width"
    [presetSettings]="presetSettings"
    [clientOptions]="clientOptions"
    (selectionModeChange)="panelsListSelectionModeChange($event)"
    (cloneSelectedPanels)="cloneSelectedPanels($event)"
    (panelFileAttached)="attachPanelFile($event)">
  </csl-panel-list-v2>
</div>
